import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "quick-add"
};
const _hoisted_2 = {
  class: "quick-add-header"
};
const _hoisted_3 = {
  class: "quick-add-title"
};
const _hoisted_4 = ["href", "aria-label"];
const _hoisted_5 = {
  class: "quick-add-form"
};
const _hoisted_6 = {
  class: "quick-add-inputbox"
};
const _hoisted_7 = ["aria-label", "placeholder"];
const _hoisted_8 = ["disabled", "aria-label"];
const _hoisted_9 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_LoadingDots = _resolveComponent("LoadingDots");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_LoadingDots, {
    loading: $data.loading
  }, null, 8, ["loading"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("h4", _hoisted_3, _toDisplayString($options.getI18nMessage('cart.rightRail.quickAdd')), 1), _createElementVNode("a", {
    class: "quick-add-text",
    href: $data.addMultipleItemsLink,
    "aria-label": $options.getI18nMessage('cart.rightRail.addMultipleItems')
  }, " + " + _toDisplayString($options.getI18nMessage('cart.rightRail.addMultipleItems')), 9, _hoisted_4)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_withDirectives(_createElementVNode("input", {
    class: _normalizeClass(["quick-add-form-number", {
      'quick-add-form-error-outline': $data.errorMessage
    }]),
    "aria-label": $options.getI18nMessage('quickOrderForm.body.td.input.placeHolder'),
    id: "quickAddInput",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.inputText = $event),
    onInput: _cache[1] || (_cache[1] = (...args) => $options.handleInput && $options.handleInput(...args)),
    onBlur: _cache[2] || (_cache[2] = (...args) => $options.removeValidationMessage && $options.removeValidationMessage(...args)),
    type: "text",
    placeholder: $options.getI18nMessage('quickOrderForm.body.td.input.placeHolder'),
    onKeydown: _cache[3] || (_cache[3] = _withKeys((...args) => $options.submitInput && $options.submitInput(...args), ["enter"]))
  }, null, 42, _hoisted_7), [[_vModelText, $data.inputText]]), _createElementVNode("button", {
    type: "button",
    class: "quick-add-form-button",
    disabled: $data.isButtonDisabled,
    "aria-label": $options.getI18nMessage('button.add.UPPER'),
    onClick: _cache[4] || (_cache[4] = (...args) => $options.submitInput && $options.submitInput(...args)),
    onKeydown: _cache[5] || (_cache[5] = _withKeys((...args) => $options.submitInput && $options.submitInput(...args), ["enter"])),
    onBlur: _cache[6] || (_cache[6] = (...args) => $options.removeValidationMessage && $options.removeValidationMessage(...args))
  }, _toDisplayString($options.getI18nMessage('button.add.UPPER')), 41, _hoisted_8)]), $data.errorMessage ? (_openBlock(), _createElementBlock("p", {
    key: 0,
    class: "quick-add-form-error",
    innerHTML: $options.getI18nMessage('quickOrderForm.validate.material')
  }, null, 8, _hoisted_9)) : _createCommentVNode("", true)])]);
}